export const WORK_GET_STATUSES_LIST = 'WORK_GET_STATUSES_LIST';
export const WORK_GET_STATUSES_LIST_SUCCESS = 'WORK_GET_STATUSES_LIST_SUCCESS';
export const WORK_GET_STATUSES_LIST_ERROR = 'WORK_GET_STATUSES_LIST_ERROR';